import { FolderUpdateApi } from '../models/api'

import { Injectable } from '@angular/core'
import { FolderVersion } from '@app/core/model/folder-version.model'
import { formatDateIntoUTC } from '@app/shared/components/ui-components/scope-ui-datepicker/scope-ui-datepicker.const'

@Injectable({ providedIn: 'root' })
export class FolderOverviewApiMappingService {
  mapFolderToUpdateApi = (folder: FolderVersion): FolderUpdateApi => ({
    name: folder.name,
    description: folder.description,
    endDate: formatDateIntoUTC(folder.endDate),
    startDate: formatDateIntoUTC(folder.startDate),
    owner: folder.owner,
    secondParty: folder.secondParty,
    secondPartyContact: folder.secondPartyContact,
  })
}
